/**
 * props:
 * - data
 * - onViewClick
 * - onDeleteClick
 */
function BacktestRow(props) {
    function getStatus() {
        const backtest = props.data;
        if (backtest.status === 'running')
            return (
                <span className="text-info">
                    <span
                        className="spinner-border spinner-border-sm me-1"
                        role="status"
                        aria-hidden="true"
                    ></span>
                    RUNNING
                </span>
            );
        if (backtest.status === 'error')
            return <span className="text-danger">ERROR</span>;
        return <span className="text-success">DONE</span>;
    }

    function getPerc(value) {
        // DECIMAL columns come back from the API as strings
        const perc = Number(value);
        if (value === null || value === undefined || Number.isNaN(perc))
            return '';

        let className = 'badge bg-secondary py-1';
        if (perc > 0) {
            value = '+' + perc.toFixed(2) + '%';
            className = 'badge bg-success py-1';
        } else if (perc < 0) {
            value = perc.toFixed(2) + '%';
            className = 'badge bg-danger py-1';
        } else {
            value = '0%';
        }

        return <span className={className}>{value}</span>;
    }

    function getDate(date) {
        return date
            ? Intl.DateTimeFormat('en-GB', {
                  dateStyle: 'short',
                  timeStyle: 'short',
              }).format(new Date(date))
            : '';
    }

    return (
        <tr>
            <td>{getDate(props.data.createdAt)}</td>
            <td>{props.data.symbol}</td>
            <td>{getStatus()}</td>
            <td>{getPerc(props.data.basePerc)}</td>
            <td>{getPerc(props.data.quotePerc)}</td>
            <td>{getPerc(props.data.totalPerc)}</td>
            <td>
                {props.data.operations
                    ? `${props.data.operations} (${props.data.buys}B/${props.data.sells}S)`
                    : ''}
            </td>
            <td>
                <button
                    id={'view' + props.data.id}
                    type="button"
                    className="btn btn-secondary btn-xs ms-2"
                    title="View this Backtest"
                    onClick={props.onViewClick}
                >
                    <svg
                        className="icon icon-xs"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M10 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" />
                        <path
                            fillRule="evenodd"
                            d="M.664 10l.59-.65a7.5 7.5 0 0110.372-6.734l-.24.435A6.5 6.5 0 004.18 10l.595.645a7.5 7.5 0 0010.372 6.734l-.24.435A7.5 7.5 0 011.254 10.65L.664 10z"
                            clipRule="evenodd"
                        />
                        <path
                            fillRule="evenodd"
                            d="M10 6.5a3.5 3.5 0 100 7 3.5 3.5 0 000-7z"
                            clipRule="evenodd"
                        />
                    </svg>
                </button>
                {props.data.status !== 'running' ? (
                    <button
                        id={'delete' + props.data.id}
                        type="button"
                        className="btn btn-danger btn-xs ms-2"
                        title="Delete this Backtest"
                        onClick={props.onDeleteClick}
                    >
                        <svg
                            className="icon icon-xs"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                clipRule="evenodd"
                            />
                        </svg>
                    </button>
                ) : (
                    <></>
                )}
            </td>
        </tr>
    );
}

export default BacktestRow;
